import { useEffect } from 'react'

import { CashflowBarGraph } from './CashflowBarGraph'
import { CashflowReport } from './CashflowReport'
import { useAnalyticsView } from '@/features/amplitude'
import { PageHeader } from '@/components/PageHeader'
import { FreeTrialUnreviewedAlert } from '@/components/FreeTrialUnreviewedAlert'

export const YearlyReportsPanel = () => {
  const pageView = useAnalyticsView()
  useEffect(() => {
    pageView('annual report')
  }, [pageView])

  return (
    <>
      <PageHeader header="Annual Reports" className="mb-4" />
      <FreeTrialUnreviewedAlert />
      <CashflowBarGraph />
      <CashflowReport />
    </>
  )
}
